import Svg, { Circle, G, Path, Rect } from 'react-native-svg';

import React from 'react';
import { SimpleIconProps } from 'src/core';

const HealthRecordsIcon = ({ size = 40, color = '#46D7CB', backgroundColor = '#DCFBED' }: SimpleIconProps) => (
  <Svg width={`${size}px`} height={`${size}px`} viewBox="0 0 40 40">
    <G>
      {/* Circle */}
      <Circle cx="20" cy="20" r="20" fill={backgroundColor} />

      {/* Move icon to center */}
      <G transform="translate(8 8)">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.5 3.5C8.5 2.67158 9.17155 2 10 2H14C14.8285 2 15.5 2.67158 15.5 3.5H17.5C18.3285 3.5 19 4.17158 19 5V20.5C19 21.3284 18.3285 22 17.5 22H6.5C5.67155 22 5 21.3284 5 20.5V5C5 4.17158 5.67155 3.5 6.5 3.5H8.5ZM8.5 4.5H6.5C6.22385 4.5 6 4.72386 6 5V20.5C6 20.7761 6.22385 21 6.5 21H17.5C17.7761 21 18 20.7761 18 20.5V5C18 4.72386 17.7761 4.5 17.5 4.5H15.5C15.5 5.32845 14.8285 6 14 6H10C9.17155 6 8.5 5.32845 8.5 4.5ZM10 3C9.72385 3 9.5 3.22386 9.5 3.5V4.5C9.5 4.77614 9.72385 5 10 5H14C14.2761 5 14.5 4.77614 14.5 4.5V3.5C14.5 3.22386 14.2761 3 14 3H10Z"
          fill={color}
        />

        {/* plus */}
        <Rect x="11" y="11" width="2" height="6" fill={color} />
        <Rect x="9" y="13" width="6" height="2" fill={color} />
      </G>
    </G>
  </Svg>
);

export default HealthRecordsIcon;
